import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";
import { Button, Text, Spacer } from "../../atoms";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

import { useFetchVenue } from "../../../networks";
import AllGuestBanner from "../AllGuestBanner";
import useWindowSize from "../../../hooks/useWindowSize";
import analytics from "../../../utils/analytics";
import classNames from "classnames";
import { func } from "../../../utils";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/venue/`;

const Lokasi = ({ city }) => {
  const { data: dataVenue } = useFetchVenue(city);
  const venue = dataVenue?.data?.data?.venue ?? {};
  const { size } = useWindowSize();
  const lat = Number(venue?.latitude);
  const lng = Number(venue?.longitude);
  const urlMap = `http://maps.google.com/maps?q=${lat},${lng}`;
  const urlOSM = `https://www.openstreetmap.org/export/embed.html?bbox=${
    lng - 0.01
  }%2C${lat - 0.01}%2C${lng + 0.01}%2C${
    lat + 0.01
  }&amp;layer=mapnik;&marker=${lat},${lng}`;
  const isMobileView = (size?.width || 0) <= 830;

  const _renderLocMobileView = () => {
    return (
      <div className="lokasi__inner">
        <div className="lokasi__inner__left">
          <Text
            className="lokasi__inner__card__title leading-normal"
            size="medium"
            weight="bold"
            color={city === "soc" ? "white" : "dark"}
          >
            {venue?.event_location || "-"}
          </Text>
          <Text
            className="lokasi__inner__left__text"
            color={city === "soc" ? "white" : "dark"}
          >
            {venue?.event_address || "-"}
          </Text>
          <Button
            className={"lokasi__inner__button mt-[8px]"}
            onClick={() => {
              const payload = {
                event: `getDirectionPiala_${city ?? analytics.defaultCity}`,
              };
              analytics.sendEvent(payload);
              window.open(urlMap, "_blank").focus();
            }}
          >
            Lihat Peta
          </Button>
        </div>
      </div>
    );
  };

  const _renderLocDesktopView = () => {
    return (
      <div
        className={classNames(
          "lokasi-detail",
          city === "soc" ? "bg-[#1F2D3D] text-white bg-none" : ""
        )}
      >
        <div className="lokasi__inner">
          <div className="lokasi__inner__left">
            <Text
              className="lokasi__inner__card__title leading-normal"
              size="medium"
              weight="bold"
              color={city === "soc" ? "white" : "dark"}
            >
              {venue?.event_location || "-"}
            </Text>
            <Text
              className="lokasi__inner__left__text"
              color={city === "soc" ? "white" : "dark"}
            >
              {venue?.event_address || "-"}
            </Text>
            <Button
              className={"lokasi__inner__button"}
              onClick={() => {
                const payload = {
                  event: `getDirectionPiala_${city ?? analytics.defaultCity}`,
                };
                analytics.sendEvent(payload);
                window.open(urlMap, "_blank").focus();
              }}
            >
              Lihat Peta
            </Button>
          </div>
        </div>
        {lat && lng && (
          <MapContainer
            center={[lat, lng]}
            zoom={13}
            scrollWheelZoom={false}
            className="lokasi-detail__embed-map"
            style={{ width: 488, height: 254 }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[lat, lng]}></Marker>
          </MapContainer>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className="lokasi bg-no-repeat bg-cover text-white"
        style={{
          background: `url(${func.getStaticImg(
            "/bg/bg-swoosh-blur.png"
          )}) #1F2D3D 100% / cover no-repeat`,
        }}
      >
        <div className="lokasi__inner" id="container">
          <Text
            className="lokasi__title mt-16"
            size="large"
            weight="bold"
            color={"white"}
          >
            {"Denah & Lokasi"}
          </Text>
          <div className="lokasi__inner__card lokasi__inner__card__without-background">
            <img
              className="lokasi__inner__card__image"
              //src={getStaticImg("/illustration/layout-venue.svg")}
              src={`${
                isMobileView
                  ? imgPath + venue?.key_visual_mobile
                  : imgPath + venue?.key_visual
              }`}
            />
          </div>
          <Spacer marginTop={24} />
          {isMobileView ? _renderLocMobileView() : _renderLocDesktopView()}

          {/* {city === "semarang" && (
            <AllGuestBanner
              bgsize={size?.width <= 992 ? "contain,cover" : "cover"}
            />
          )} */}
        </div>
      </div>
    </>
  );
};

export default Lokasi;
